import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20landscape%20with%20misty%20mountains%20pine%20trees%20and%20golden%20morning%20light%20traditional%20ink%20wash%20painting%20aesthetic%20flowing%20water%20crane%20birds%20in%20distance%20serene%20sublime%20atmosphere%20soft%20warm%20tones%20elegant%20oriental%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="高义白洁"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p className="text-primary-300 font-label text-sm md:text-base tracking-[0.2em] mb-4 animate-[fadeInUp_0.8s_ease]">
          传承中华美德 · 弘扬高洁精神
        </p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold text-white mb-6 animate-[fadeInUp_0.8s_ease_0.15s] max-w-3xl leading-tight">
          高义白洁
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl leading-relaxed mb-8 animate-[fadeInUp_0.8s_ease_0.3s]">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 animate-[fadeInUp_0.8s_ease_0.45s]">
          <Link
            to="/category/wenhua-neihan"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
          >
            探索文化内涵
          </Link>
          <Link
            to="/category/xiandai-jiazhi"
            className="px-8 py-3.5 bg-white/15 text-white border border-white/30 font-medium rounded-md hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解现代价值
          </Link>
        </div>
      </div>
    </section>
  );
}